
import Component from "vue-class-component";
import Vue from "vue";
import { Prop } from "vue-property-decorator";
import AdditionalInfoButton from "@/features/shared/components/AdditionalInfoButton.vue";
import { ApplicationsClient, EditAdditionalInfoRequest, IssueDocumentClient } from "@/api-client";
import toasts from "@/components/Toasts";
import LabelOptional from "@/features/shared/components/LabelOptional.vue";

@Component({
  components: {
    AdditionalInfoButton,
    LabelOptional
  },
})
export default class ApplicationAdditionalInfoInput extends Vue {
  @Prop({ required: true })
  applicationId!: string;
  additionalInfo = "";

  async created() {
    await new ApplicationsClient().getAdditionalInfo(this.applicationId).then(data=>{
        this.additionalInfo = data;
    }).catch(()=>{
        toasts.failure(this.$ls.Global_Error_ClientSideErrorOnPage);
    })
  }

  async save(value: string) {
    const data = new EditAdditionalInfoRequest({ additionalInfo: value });
    await new IssueDocumentClient()
      .editAdditionalInfo(data, this.applicationId)
      .then(() => {
        toasts.success(
          this.$ls.Applications_IssueDocument_Toast_Success_DocumentSeedSaved
        );
        this.$emit("application-changed");
      })
      .catch(() => {
        toasts.failure(this.$ls.Global_Error_ClientSideErrorOnPage);
      });
  }

  onBlurSave() {  
    this.save(this.additionalInfo);
  }
}
